"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scope = void 0;
var Scope;
(function (Scope) {
    Scope["AgentRead"] = "OIDC.Employees.Agent.Read";
    Scope["AgentWrite"] = "OIDC.Employees.Agent.Write";
    Scope["CustomersBotRead"] = "OIDC.Customers.Bot.Read";
    Scope["CustomersExternalRead"] = "OIDC.Customers.External.Read";
    Scope["CustomersRead"] = "OIDC.Customers.Internal.Read";
    Scope["CustomersWrite"] = "OIDC.Customers.Internal.Write";
    Scope["IdentificationServiceAcquisitionScore"] = "identification-service.acquisition-score";
    Scope["IdentificationServiceSearch"] = "identification-service.search";
    Scope["IdentificationServiceSearchBatch"] = "identification-service.search-batch";
    Scope["OfferstoreStoreOfferFeedback"] = "offerstore.store-offer-feedback";
    Scope["OfferStoreGetNextBestOffer"] = "offerstore.get-nextbestoffer";
    Scope["ProspectsRead"] = "OIDC.Customers.Prospect.Read";
    Scope["ProspectsWrite"] = "OIDC.Customers.Prospect.Write";
    Scope["SalesPartnersDirectRead"] = "OIDC.Salespartners.Direct.Read";
    Scope["SalesPartnersDirectWrite"] = "OIDC.Salespartners.Direct.Write";
    Scope["SalesPartnersIndirectRead"] = "OIDC.Salespartners.Indirect.Read";
    Scope["SalesPartnersIndirectWrite"] = "OIDC.Salespartners.Indirect.Write";
    Scope["SalesPartnersRead"] = "OIDC.Salespartners.Read";
    Scope["SalesPartnersWrite"] = "OIDC.Salespartners.Write";
    Scope["SourcingPartnersWrite"] = "OIDC.SourcingPartners.Write";
    Scope["ServicePartnersWrite"] = "OIDC.Servicepartners.Write";
    Scope["ServicePartnersRead"] = "OIDC.Servicepartners.Read";
})(Scope = exports.Scope || (exports.Scope = {}));
